import React from 'react';
import {
    AdminGuard,
    GuestGuard,
} from '../guards/RolesGuard';
import Register from '../features/auth/register';
import ResetPassword from '../features/auth/reset-password';
import Layout from '../container/Layout';
import Intro from '../features/dashboard/intro/Intro';
import AiAuth from '../features/ai-auth/AiAuth';
import Homepage from '../features/dashboard/dashboards-options';
import ChatHistory from '../features/dashboard/history/ChatHistory';
import Chats from '../features/dashboard/chats/Chats';
import { UserGuard } from '../guards/UserGuard';
import Faqs from '../features/dashboard/faqs/Faqs';
import TripLogin from '../features/staff/trips-login/TripLogin';
import RootRedirect from '../shared/RootRedirect';
import LayoutAdmin from '../container/LayoutAdmin';
import HomepageAdmin from '../features/admin/homepage';
import RegisterStaff from '../features/admin/register-staff/RegisterStaff';
import Settings from '../features/dashboard/settings';
// import WelcomePage from '../features/auth/welcome';

export interface RouteDefinition {
    path: string;
    element: JSX.Element;
    guard?: () => boolean;
    index?: string;
    key?: string;
    childrens?: RouteDefinition[];
}

export const routes: RouteDefinition[] = [
    {
        path: '/auth',
        element: <AiAuth />,
        key: 'guest',
        guard: GuestGuard,
    },
    {
        path: '/apply',
        element: <Register />,
        key: 'guest',
        guard: GuestGuard,
    },
    {
        path: '/reset-password',
        element: <ResetPassword />,
        key: 'guest',
        guard: GuestGuard,
    },
    {
        path: '/',
        index: 'redirect',
        element: <RootRedirect />,
        guard: UserGuard,
    },
    {
        path: '/staff',
        element: <Layout />,
        index: 'home',
        key: 'broker',
        guard: UserGuard,
        childrens: [
            {
                path: 'home',
                element: <Homepage />
            },
            {
                path: 'trips-login',
                element: <TripLogin />
            },
            {
                path: 'history',
                element: <ChatHistory />
            },
            {
                path: 'intro',
                element: <Intro />
            },
            {
                path: 'chat/:id',
                element: <Chats />
            },
            {
                path: 'faqs',
                element: <Faqs />
            }
        ]
    },
    {
        path: '/insights-admin',
        element: <LayoutAdmin />,
        index: 'admin',
        key: 'insights-admin',
        guard: AdminGuard,
        childrens: [
            {
                path: '',
                element: <HomepageAdmin />
            },
        ]
    },
    {
        path: '/admin',
        element: <LayoutAdmin />,
        index: 'home',
        key: 'register',
        guard: AdminGuard,
        childrens: [
            {
                path: 'register',
                element: <RegisterStaff />
            },
        ]
    },
    {
        path: '/settings',
        element: AdminGuard() ? <LayoutAdmin /> : <Layout />,
        key: 'admin',
        guard: UserGuard,
        childrens: [
            {
                path: '',
                element: <Settings />
            }
        ]
    },

];
